// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Invoice  {
    _originalTypeClassName = "Loom.BO.Invoice";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Invoice.translate = translateService;
}
this.Taxes = [];
this.InvoiceItems = [];
this.Id = null;
this.InvoiceNumber = null;
this.InvoiceDate = null;
this.exchangeRate = null;
this.NetAmount = null;
this.VatAmount = null;
this.VatPercentage = null;
this.AmountWithVat = null;
this.TotalTaxAmount = null;
this.FinalPayableAmount = null;
this.Comments = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
InvoiceNumber:any;
InvoiceDate:any;
exchangeRate:any;
NetAmount:any;
VatAmount:any;
VatPercentage:any;
AmountWithVat:any;
TotalTaxAmount:any;
FinalPayableAmount:any;
Comments:any;
Description:any;
EmploymentContract:any;
Currency:any;
Taxes:any;
InvoiceDocument:any;
InvoiceItems:any;
static setEmploymentContract = ($this, value) => {
var oldValue = $this.EmploymentContract;
$this.EmploymentContract = value;
if (value != null) {
}
}
static setCurrency = ($this, value) => {
var oldValue = $this.Currency;
$this.Currency = value;
if (value != null) {
}
}
static setTaxes = ($this, items) => {
                if (items == null) items = [];
                if ($this.Taxes == null) $this.Taxes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Taxes.length > 0) {
                    Domain.Invoice.removeTaxes($this, $this.Taxes[0]);
                }

                Domain.Invoice.addManyTaxes($this, copyItems);
            }
static addManyTaxes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Invoice.addTaxes($this, items[i]);
                }
            }
static addTaxes = ($this, item) => {
                if ($this.Taxes == null) $this.Taxes = [];
                if (item == null || $this.Taxes.indexOf(item) > -1) return;
                $this.Taxes.push(item);
if (item.Invoice != $this) {
Domain.InvoiceTax.setInvoice(item, $this);
}
}
static addRangeTaxes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Invoice.addTaxes($this, item));
            }
static removeTaxes = ($this, item) => {
                if ($this == null || $this.Taxes == null || $this.Taxes.indexOf(item) === -1) return;
                var _index = $this.Taxes.indexOf(item);
                $this.Taxes.splice(_index, 1);
item.Invoice = null;
}
static clearTaxes = ($this) => { $this.Taxes = null; }
static setInvoiceDocument = ($this, value) => {
var oldValue = $this.InvoiceDocument;
$this.InvoiceDocument = value;
if (value != null) {
}
}
static setInvoiceItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.InvoiceItems == null) $this.InvoiceItems = [];

                const copyItems = Common.cloneObject(items);

                while ($this.InvoiceItems.length > 0) {
                    Domain.Invoice.removeInvoiceItems($this, $this.InvoiceItems[0]);
                }

                Domain.Invoice.addManyInvoiceItems($this, copyItems);
            }
static addManyInvoiceItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Invoice.addInvoiceItems($this, items[i]);
                }
            }
static addInvoiceItems = ($this, item) => {
                if ($this.InvoiceItems == null) $this.InvoiceItems = [];
                if (item == null || $this.InvoiceItems.indexOf(item) > -1) return;
                $this.InvoiceItems.push(item);
if (item.Invoice != $this) {
Domain.InvoiceItem.setInvoice(item, $this);
}
}
static addRangeInvoiceItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Invoice.addInvoiceItems($this, item));
            }
static removeInvoiceItems = ($this, item) => {
                if ($this == null || $this.InvoiceItems == null || $this.InvoiceItems.indexOf(item) === -1) return;
                var _index = $this.InvoiceItems.indexOf(item);
                $this.InvoiceItems.splice(_index, 1);
item.Invoice = null;
}
static clearInvoiceItems = ($this) => { $this.InvoiceItems = null; }

static GetAmountWithVat($this: any): any{return Joove.Common.safeNumber(Domain.Invoice.GetNetAmount($this)) + Joove.Common.safeNumber(Domain.Invoice.GetVatAmount($this));
}
static GetExchangeRateSafe($this: any): any{let rate = 0.0;
if ((CLMS.Framework.Number.NotEqual(() => $this.exchangeRate, () => null))) {rate = $this?.exchangeRate;}
return rate;
}
static GetFinalPayableAmount($this: any): any{return Joove.Common.safeNumber(Domain.Invoice.GetAmountWithVat($this)) - Joove.Common.safeNumber(Domain.Invoice.GetTotalTaxAmount($this));
}
static GetNetAmount($this: any): any{return $this?.InvoiceItems?.linq?.sum((a) => Domain.InvoiceItem.GetTotal(a));
}
static GetTotalTaxAmount($this: any): any{return $this?.Taxes?.linq?.sum((a) => Domain.InvoiceTax.GetAmount(a));
}
static GetVatAmount($this: any): any{return Joove.Common.safeNumber(Domain.Invoice.GetNetAmount($this)) * Joove.Common.safeNumber($this?.VatPercentage);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}